import { render, staticRenderFns } from "./we-goods.vue?vue&type=template&id=7b179edb&"
import script from "./we-goods.vue?vue&type=script&lang=js&"
export * from "./we-goods.vue?vue&type=script&lang=js&"
import style0 from "./we-goods.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports